/***************************************************************
6/9/2017
Alexander Self
Floating action button for navigation
***************************************************************/
import { Link, browserHistory } from 'react-router';
import React from 'react';
const $ = window.$;


const ActionMenuButton = ({ urls }) => {
  return (
    <div className="fixed-action-btn click-to-toggle">
      <a className="btn-floating btn-large red" onMouseOver={() => $('.fixed-action-btn').openFAB()}
        onMouseLeave={() => { setTimeout(() => {$('.fixed-action-btn').closeFAB()}, 4000)}}>
        <i className="large material-icons">more_vert</i>
      </a>
      <ul>
        {
          urls.map((url) => (
            <li key={url.url} onClick={() => { browserHistory.push(`${url.url}`); $('.fixed-action-btn').closeFAB(); }}>
              <Link className={`btn-floating ${url._class}`} to={`${url.url}`}><i className="material-icons">{url.icon}</i></Link>
            </li>
          ))
        }
        <li key={`weather8`} onClick={() => { browserHistory.push(`/weather`); $('.fixed-action-btn').closeFAB(); }}>
          <Link className={`btn-floating`} to={`/weather`}><i className={`wi wi-day-rain orange lighten-2 circle`}></i></Link>
        </li>
      </ul>
    </div>
  );
};

export default ActionMenuButton;




























/* END */



// WEBPACK FOOTER //
// ./src/components/action_button.js